import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { EditActions, editActions } from "../../../actions/editActions";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { pdApiActions, PdApiActions } from "../../../actions/pdApiActions";
import { ioConfigActions } from "../../../actions/ioConfigActions";
import { warning } from "react-notification-system-redux";
import EditDevelopmentPackage from "../../Editing/EditDevelopmentPackage";

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  ioConfig: State.IoConfig;
  selectedIoConfiguration: string;
  toggleModal: () => void;
  isModalOpen: boolean;
};

type DispatchProps = {
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  ioConfigActions: typeof ioConfigActions;
  showWarning: typeof warning;
};

type OwnProps = {};
export type DevelopmentPackageProps = StateProps & DispatchProps & OwnProps;
const DevelopmentPackage = (props: DevelopmentPackageProps) => {
  const [isModalOpen, SetModalOpen] = React.useState<boolean>(false);

  const toggleModal = (): void => {
    SetModalOpen(!isModalOpen);
  };
  useEffect(() => {
    props.pdApiActions.fetchIoConfigurations();
  }, []); // eslint-disable-line

  const { columns, mainState, isEditActive, ioConfig } = props;
  const { editSize } = mainState;
  let selectedColumns: State.Column[] = [];

  selectedColumns = columns["IO Configurations"];

  // Add submenu specific columns and rows
  return (
    <div className="select-configurations-view">
      <div className="io-wrapper">
        <div className="io-header">
          <h2>Select product version</h2>
        </div>
        <div className="io-content-wrapper">
          <Table
            rows={ioConfig.ioConfigurations || []}
            loading={ioConfig.localFetchingStatus === "Fetching"}
            loadingText="Fetching Io Configurations..."
            columns={selectedColumns}
            isHidingTextActive={false}
            handleRowSelection={props.editActions.select}
            isRowSelected={() => false}
            pageSize={20}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditDevelopmentPackage toggleModal={toggleModal} />
            </div>
          </Dimmer>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  pdApi: state.pdApi,
  ioConfig: state.ioConfig,
  selectedIoConfiguration: state.ioConfig.selectedIoConfiguration
});
const mapDispatchToProps = (dispatch: Dispatch<EditActions | PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DevelopmentPackage);
